<div>
  @if (activity.isLoggedActivity) {
    @if (isActivityValid()) {
      <div class="activity-card" [ngClass]="{ 'last-activity-card': isLast }">
        <ng-template #taskSubtitle>
          <ng-container
            *ngTemplateOutlet="
              (activity | crmIsTaskOverdue) ? taskOverdueSubtitle : taskDueSubtitle;
              context: { activity }
            "
          ></ng-container>
        </ng-template>
        <crm-activity-template
          [activity]="activity"
          [ownerUser]="activity.ownerUser"
          [isOwnedByServiceAccount]="activity.ownerId === ''"
          [subtitleTemplate]="activity.crmObjectSubtype === 'Task' ? taskSubtitle : undefined"
          [showPrimaryAssociation]="!crmObjectIdentifier().crmObjectId"
        >
          @if (!editMode) {
            @switch (activity.crmObjectSubtype) {
              @case ('Note') {
                <crm-activity-logged-note [activity]="activity"></crm-activity-logged-note>
              }
              @case ('Email') {
                <crm-activity-logged-email [activity]="activity"></crm-activity-logged-email>
              }
              @case ('Call') {
                <crm-activity-logged-call [activity]="activity"></crm-activity-logged-call>
              }
              @case ('Meeting') {
                <crm-activity-logged-meeting [activity]="activity"></crm-activity-logged-meeting>
              }
              @case ('Task') {
                <crm-activity-task
                  [activity]="activity"
                  (activityChange)="updateActivity($event)"
                  [associatedObject]="crmObjectIdentifier()"
                  [users]="uniqueUsers$ | async"
                ></crm-activity-task>
              }
              @case ('Communication') {
                <crm-activity-logged-communication [activity]="activity"></crm-activity-logged-communication>
              }
            }
          } @else {
            @if (activity | crmTimelineAssociatedObject: crmObjectIdentifier(); as crmActivity) {
              <crm-activity-logger
                crm-activity-template-edit
                [crmObjectId]="crmActivity.crmObjectId"
                [objectType]="crmActivity.objectType"
                [crmActivityId]="activity.crmObjectId!"
                [expandAndSelectType]="activity.crmObjectSubtype"
                [hideCrmObjectAssociations]="hideCrmAssociations()"
                [activityOwner]="activity.ownerUser"
                (cancel)="editMode = false"
                (activityUpdated)="updateActivity($event)"
              ></crm-activity-logger>
            }
          }
          <crm-association-popover [activity]="activity"></crm-association-popover>
          @if (!editMode) {
            <div class="activity-options-menu" crmActivityTemplateOptions>
              <mat-menu #activityOptionsMenu="matMenu">
                <button mat-menu-item (click)="editMode = true">
                  {{ 'ACTIVITY.MENU.EDIT' | translate }}
                </button>
                @if (showCopyLink()) {
                  <button mat-menu-item (click)="copyLinkToActivity()">
                    {{ 'ACTIVITY.MENU.COPY_LINK' | translate }}
                  </button>
                }
              </mat-menu>
              <button mat-icon-button [matMenuTriggerFor]="activityOptionsMenu">
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>
          }
        </crm-activity-template>
      </div>
    }
  } @else {
    @if (isActivityValid()) {
      <div class="activity-card" [ngClass]="{ 'last-activity-card': isLast }">
        @switch (activity.crmObjectSubtype) {
          @case ('RecordChange') {
            <crm-activity-record-change [activity]="activity"></crm-activity-record-change>
          }
          @case ('Note') {
            <crm-activity-note [activity]="activity"></crm-activity-note>
          }
          @case ('Email') {
            <crm-activity-email
              [activity]="activity"
              [associatedObjectId]="crmObjectIdentifier().crmObjectId"
              [objectType]="crmObjectIdentifier().objectType"
            ></crm-activity-email>
          }
          @case ('Call') {
            <crm-activity-call
              [activity]="activity"
              [associatedObjectId]="crmObjectIdentifier().crmObjectId"
              [objectType]="crmObjectIdentifier().objectType"
            ></crm-activity-call>
          }
          @case ('Communication') {
            <crm-activity-communication
              [activity]="activity"
              [associatedObjectId]="crmObjectIdentifier().crmObjectId"
              [objectType]="crmObjectIdentifier().objectType"
            ></crm-activity-communication>
          }
          @case ('OpportunityChange') {
            <crm-activity-opportunity-updated [activity]="activity"></crm-activity-opportunity-updated>
          }
          @case ('Meeting') {
            <crm-activity-meeting
              [cardInfo]="activity"
              [associatedObjectId]="crmObjectIdentifier().crmObjectId"
              [objectType]="crmObjectIdentifier().objectType"
            ></crm-activity-meeting>
          }
        }
      </div>
    }
  }
</div>

<ng-template #taskDueSubtitle let-activity="activity">
  <div>{{ 'ACTIVITY.DUE' | translate }}: {{ activity | crmActivityEffectiveDate | date: dateFormat }}</div>
</ng-template>

<ng-template #taskOverdueSubtitle let-activity="activity">
  <div class="activity-overdue-subtitle">
    <mat-icon>alarm</mat-icon>
    <span>{{ 'ACTIVITY.OVERDUE' | translate }}: {{ activity | crmActivityEffectiveDate | date: dateFormat }}</span>
  </div>
</ng-template>
